export default __webpack_public_path__ + "static/media/The Water's Edge.218b81e8.jpg";